import RedactionTextPreview from './RedactionTextPreviewContainer';

export default RedactionTextPreview;